// extracted by mini-css-extract-plugin
module.exports = {"container":"Import_container__3VKxD","row":"Import_row__3X8G1"};